<script setup lang="ts">
import type { PropType } from 'vue'
import { useAttrs } from 'vue'

defineProps({
  title: String as PropType<string>,
  childrenClass: String as PropType<string>,
  isBlack: Boolean as PropType<boolean>,
  isMore: Boolean as PropType<boolean>,
  height: Number as PropType<number>,
  childrenTop: Number as PropType<number>,
  isContainer: {
    type: Boolean as PropType<boolean>,
    default: true
  }
})

const attrs = useAttrs()
</script>

<template>
  <div :class="isContainer ? 'c-container' : ''" v-bind="attrs">
    <div :class="[ 'column-line-block', isBlack ? 'black' : '' ]" :style="{ height: `${height || 24}px` }">
      <i w-full h-2px bg-hex-main/>
      <div class="column-title">
        {{ title }}
        <span v-if="isMore" class="text-font-bold text-14px leading-17px flex items-center mt-4px cursor-pointer">
          MORE
          <svg-icon v-if="isBlack" relative class="top-[-0.5px]" w-10px h-10px name="home-columnMore"/>
          <svg-icon v-else relative class="top-[-0.5px]" w-10px h-10px name="home-moreNextRed"/>
        </span>
      </div>
    </div>
    <div :class="childrenClass" :style="{ marginTop: `${childrenTop || 24}px` }">
      <slot/>
    </div>
  </div>
</template>

<style scoped lang="less">
.column-line-block {
  --at-apply: relative w-full flex items-center;
  
  &.black {
    i {
      --at-apply: bg-white;
    }
    
    .column-title {
      --at-apply: px-33\.5px text-white leading-24px bg-hex-main-black;
    }
  }
  
  i {
    --at-apply: w-full h-2px bg-hex-main;
  }
  
  .column-title {
    --at-apply: flex items-center flex-col text-hex-main text-font-bold text-20px leading-20px absolute position-center px-23px bg-white;
  }
}

.column-children {

}
</style>
